/* eslint-disable import/extensions */
/*
 *
 * PaymentMethods actions
 *
 */

import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_BANK_ACCOUNTS,
  SAVE_BANK_ACCOUNTS_RESPONSE,
  RESET_DATA,
  GET_REFUND_RECHARGE,
  SAVE_REFUND_RECHARGE,
  RESET_REFUND_RECHARGE,
  VERIFY_BANK_ACCOUNT,
  CANCEL_NEW_BANK_ACCOUNT,
  DISABLE_MODAL_LOADER,
  ENABLE_MODAL_LOADER,
  GET_PAYOUT_BANK_IDS,
  CREATE_SELF_SERVE_TICKET,
  GET_BANK_ACCOUNTS_DETAILS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function enableLoaderAction(data) {
  return {
    type: ENABLE_LOADER,
    data,
  };
}

export function disableLoaderAction(data) {
  return {
    type: DISABLE_LOADER,
    data,
  };
}

export function getBankAccountsAction(data) {
  return {
    type: GET_BANK_ACCOUNTS,
    data,
  };
}

export function saveBankAccountsResponse(data) {
  return {
    type: SAVE_BANK_ACCOUNTS_RESPONSE,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function verifyBankAccountAction(data) {
  return {
    type: VERIFY_BANK_ACCOUNT,
    data,
  };
}

export function cancelNewBankAccountAction(data) {
  return {
    type: CANCEL_NEW_BANK_ACCOUNT,
    data,
  };
}

export function getRefundRechargeAction(data) {
  return {
    type: GET_REFUND_RECHARGE,
    data,
  };
}

export function saveRefundRechargeAction(data) {
  return {
    type: SAVE_REFUND_RECHARGE,
    data,
  };
}

export function resetRefundRechargeAction() {
  return {
    type: RESET_REFUND_RECHARGE,
  };
}

export function enableModalLoaderAction(data) {
  return {
    type: ENABLE_MODAL_LOADER,
    data,
  };
}

export function disableModalLoaderAction(data) {
  return {
    type: DISABLE_MODAL_LOADER,
    data,
  };
}

export function getPayoutBankIdsAction(data) {
  return {
    type: GET_PAYOUT_BANK_IDS,
    data,
  };
}

export function createSelfServeTicketAction(data) {
  return {
    type: CREATE_SELF_SERVE_TICKET,
    data,
  };
}

export function getBankAccountDetailsAction(data) {
  return {
    type: GET_BANK_ACCOUNTS_DETAILS,
    data,
  };
}
